import path from 'path'

import isCADFile from './isCADFile'

const WEB_FILE_EXTENSIONS = [
    '.htm',
    '.html',
    '.hta',
    '.xhtml',
    '.css',
    '.mjs',
    '.swf',
    '.svg',
]
const EXECUTABLES_EXTENSIONS = [
    '.exe',
    '.chm',
    '.pif',
    '.reg',
    '.scr',
    '.sct',
    '.hlp',
    '.shs',
    '.shb',
    '.msi',
    '.msp',
    '.msc',
    '.class',
    '.com',
    '.dll',
    '.dmg',
    '.drv',
    '.grp',
    '.ocx',
    '.ovl',
    '.sys',
    '.vdl',
    '.vxd',
    '.jar',
    '.app',
]
const SCRIPTS_EXTENSIONS = [
    '.js',
    '.jse',
    '.vb',
    '.vbe',
    '.vbs​',
    '.pcd',
    '.wsc',
    '.wsf',
    '.wsh',
    '.ws​',
    '.hta',
    '.cmd',
    '.bat',
    '​.acc',
    '.asp',
    '.ccs',
    '.htx',
    '.je',
    '.php',
    '.php3',
    '.sbs',
    '.sct',
    '.shb',
    '.shd',
    '.vba',
    '.ws',
    '.wst',
    '.jar',
    '.ps1',
    '.ps1xml',
    '.ps2',
    '.ps2xml',
    '.psc1',
    '.psc2',
    '.msh',
    '.msh1',
    '.msh2',
    '.mshxml',
    '.msh1xml',
    '.msh2xml',
]
const LINKS_EXTENSIONS = ['.lnk', '.scf', '.ink', '.inf']
const MACROS_EXTENSIONS = [
    '.docm',
    '.dotm',
    '.xlsm',
    '.xltm',
    '.xlam',
    '.pptm',
    '.potm',
    '.ppam',
    '.ppsm',
    '.sldm',
]
const OTHERS_EXTENSIONS = ['.cpl', '.crt', '.ins', '.isp']
const BLOCK_EXTENSIONS = [
    ...WEB_FILE_EXTENSIONS,
    ...EXECUTABLES_EXTENSIONS,
    ...SCRIPTS_EXTENSIONS,
    ...LINKS_EXTENSIONS,
    ...MACROS_EXTENSIONS,
    ...OTHERS_EXTENSIONS,
]

const KNOWN_EXTENSIONS = [
    '.igs',
    '.iges',
    '.sldasm',
    '.skp',
    '.gcode',
    '.mtl',
    '.eprt',
    '.scad',
    '.max',
    '.dwf',
    '.edrw',
    '.fcstd',
    '.glb',
    '.zip',
    '.rar',
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.pdf',
    '.csv',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.doc',
    '.docx',
]

const KNOWN_EXTENSIONS_SET = new Set(KNOWN_EXTENSIONS)

const BLOCK_EXTENSIONS_SET = new Set(BLOCK_EXTENSIONS)

export const isBlockedFileName = (fileName = '') => {
    const ext = path.extname(fileName).toLowerCase()

    return Boolean(ext && BLOCK_EXTENSIONS_SET.has(ext))
}

export const isKnownExtFileName = (fileName = '') => {
    const ext = path.extname(fileName).toLowerCase()

    return Boolean(ext && KNOWN_EXTENSIONS_SET.has(ext))
}

export const isUnknownExtFile = (fileName = '') =>
    !isKnownExtFileName(fileName) &&
    !isCADFile({ name: fileName }) &&
    !isBlockedFileName(fileName)
